import(/* webpackMode: "eager" */ "/app/src/app/global-error.js");
